import flightIcon from './../../images/airservice.png';

const bookings = [
  {
    airline: 'West Jet Canada',
    date: '2024-08-15',
    departureTime: '10:30 AM',
    bookingID: 'AB123456789',
    route: 'DE - LAX',
    flightIcon: flightIcon,
  },
  {
    airline: 'Spirit Air Lines',
    date: '2024-09-20',
    departureTime: '3:45 PM',
    bookingID: 'CD987654321',
    route: 'NY - MIA',
    flightIcon: flightIcon,
  },
  

];

export default bookings;